














export default {
	props:{
		"value":Number,
		"size":{
			type:String,
			default:"sm"
		},
		"inputId":String
	},
	methods:{
		formatValue(v:any){
			if(isNaN(v)){
				return this.value;
			}
			let n = Number(v);
			return n < 0 || n > 1 ? this.value : n;
		},
		onInput(v:any){
			this.$emit("input", v);
		}
	}
}
